import { defineComponent as d, computed as o, openBlock as i, createElementBlock as c, createElementVNode as e, toDisplayString as a, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "164f9297-544f-487b-b6e4-ca9390d45bcd" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#164f9297-544f-487b-b6e4-ca9390d45bcd)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 167 256-32 256 32v178l-256 32L0 345Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v167H0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#496e2d",
  d: "M0 345h512v167H0Z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "m198 345 151-109H163l151 109-58-178Z"
}, null, -1), w = { fill: "none" }, b = ["r"], N = /* @__PURE__ */ d({
  __name: "gh",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), c("title", p, a(t.flagName), 1)) : f("", !0),
        k,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=gh-1851e2f7.js.map
